// Anything exported from this file is importable by other in-browser modules.
import { setup, tw } from "twind";

const schemaName = localStorage.getItem("schema_name")?.trim();

const headers = {
  ...(schemaName && { "x-tenant-schema": schemaName }),
};

fetch(
  "https://api.kontractlive.com/projectsettingsservice/api/configuration/",
  {
    headers,
  }
)
  .then((response) => {
    if (!response.ok) {
      throw new Error("Failed to fetch current client");
    }
    return response.json();
  })
  .then((data) => {
    console.log("here, ", data);
    const root = document.querySelector(":root");

    //@ts-ignore
    root.style.setProperty("--primary", data?.color_palettes?.primary);
    //@ts-ignore
    root.style.setProperty("--primary-light", data?.color_palettes?.secondary);
    //@ts-ignore
    root.style.setProperty("--primary-active", data?.color_palettes?.error);
    //@ts-ignore
    root.style.setProperty("--primary-hover", data?.color_palettes?.success);

    window.localStorage.setItem("primary-color", data?.color_palettes?.primary);
    window.localStorage.setItem(
      "primary-light",
      data?.color_palettes?.secondary
    );
  })
  .catch((error) => {
    console.error("Current client fetch error:", error);
  });

setup({
  theme: {
    fontFamily: {
      sans: ["Helvetica", "sans-serif"],
      serif: ["Times", "serif"],
    },
    extend: {
      colors: {
        primary: "var(--primary)",
        "primary-light": "var(--primary-light)",
        "primary-active": "var(--primary-active)",
        "primary-hover": "var(--primary-hover)",
        "text-primary": "var(--text-primary)",
        "text-secondary": "var(--text-secondary)",
        "text-disabled": "var(--text-disabled)",
        "background-default": "var(--background-default)",
        "background-paper": "var(--background-paper)",
        info: "var(--background-paper)",
        warning: "var(--background-paper)",
      },
    },
  },
});
export { tw };
